import { injectable } from 'inversify';
import { Route } from 'vue-router';

@injectable()
abstract class PageLoadTracker {
  abstract track(currentRoute: Route): void;
}

export { PageLoadTracker };
